import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import Header from "src/Component/content-component/Header";

const ImmersionTabOverview = ({ overview }) => {
  if (!overview|| !overview.programHighlights) return null;

  const midIndex = Math.ceil(overview.programHighlights.length / 2);
  const firstColumn = overview.programHighlights.slice(0, midIndex);
  const secondColumn = overview.programHighlights.slice(midIndex);

  return (
    <Box sx={{ mt: 4 }}>
      <Container>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 5 }}>
          <Header content={"Program Overview"} textAlign={"center"} />
        </Box>
        <Grid container spacing={3} sx={{ paddingBottom: "20px" }}>
          {[firstColumn, secondColumn].map((column, colIndex) => (
            <Grid key={colIndex} item lg={6} md={6} sm={12} xs={12}>
              {column.map(({ id, title, description }) => (
                <Box
                  key={id}
                  sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#00999e",
                      color: "white",
                      borderRadius: "5px",
                      padding: "5px 10px",
                      fontWeight: "bold",
                      mr: 2,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {id}
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: "bold", color: "#00999e", mb: 1 }}
                    >
                      {title}
                    </Typography>
                    {description.includes("\n") ? (
                      <ul style={{ paddingLeft: "16px", margin: 0 }}>
                        {description.split("\n").map((point, index) => (
                          <li key={index} style={{ marginBottom: "4px" }}>
                            <Typography variant="body2">{point}</Typography>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <Typography variant="body2">{description}</Typography>
                    )}
                  </Box>
                </Box>
              ))}
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ImmersionTabOverview;
